import * as aTypes from '../../action-types'
import * as mTypes from '../../mutation-types'
import api from '../../../api'

/*
const sampleOrg = {
  name: '某魔法的机构',
  address: '北京某元桥',
  website: 'www.some.com',
  phone: '010-12345678',
  fax: '010-12345678',
  mail: 'something@some.com'
}
*/

const state = {
  name: '',
  address: '',
  website: '',
  phone: '',
  fax: '',
  mail: ''
}

const actions = {
  [aTypes.CONTACT_GET_ORG] ({ commit }, { orgId, contactId }) {
    commit(mTypes.SET_LOADING, { key: aTypes.CONTACT_GET_ORG, loading: true })
    api.contact.getOrg({
      success (res) {
        const org = orgId ? res.body : (contactId ? res.body.org : {})
        const contact = (!orgId && contactId) ? res.body : null
        const payload = {
          name: org.name,
          address: org.address,
          website: org.website,
          phone: org.phone,
          fax: org.fax,
          mail: org.email
        }
        commit(mTypes.CONTACT_SET_ORG, payload)
        commit(mTypes.SET_NAV_TITLE, contact ? `${contact.name} - ${org.name}` : org.name)
        commit(mTypes.SET_LOADING, { key: aTypes.CONTACT_GET_ORG, loading: false })
      },
      commit
    }, { orgId, contactId })
  }
}

const mutations = {
  [mTypes.CONTACT_SET_ORG] (state, org) {
    state.name = org.name
    state.address = org.address
    state.website = org.website
    state.phone = org.phone
    state.fax = org.fax
    state.mail = org.mail
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/contact/org.js